const initialState = {
  newCbpForm: false,
  cboID: '',
  cboName: '',
  organization: '',
  acceptsCCCMS: '',
  cbpCode: '',
  firstReferralContact: '',
  secondReferralContact: '',
  lastVerWk: '',
  cup: '',
  modality: '',
  enhancedServicesRate: '',
  sTOPBeds: '',
  verificationContact: '',
  verificationContact2: '',
  slecupNALtrDate: '',
  cupMaxBeds: '',
  gender: '',
  blanketPurchaseAgreementDedCapSap: '',
  maxAdmits: '',
  wcVeificationContact1: '',
  wcVeificationContact2: '',
  aDPEffDate: '',
  aDPLicCert: '',
  accepts290s: '',
  foodProvided: '',
  calOMSContact: '',
  wcCalOMSContacts1: '',
  wcCalOMSContact2: '',
  aDPExpDate: '',
  ADPMaxBeds: '',
  dataDepartmentComment: '',
  sap: '',
  bPADedCap: '',
  inactive: '',
  flagged: '',
  verLock: '',
  cupNA: '',
  currentFYRateSheetReceivedandVerified: '',
  overorUnderDARSApprovedCountyRate: '',
  contractComplianceStatusNote: '',
  lowIntensity: '',
  medIntensity: '',
  highIntensity: '',
};
export default initialState;
